import { Flex } from "@chakra-ui/react";
import { SectionBox } from "../../../components/sectionBox/SectionBox";
import {
  CategoryImpressionsTable,
} from "../categoryImpressionsTable";
import { CircleChart } from "../circleChart";
import {
  BreakdownTypeEnum,
  TopSensitiveTopicsType,
} from "../../../graphqlExternal/generated";
import { DateRangeBox } from "../dateRangeBox";
import { returnRoundedNumber } from "..";

export interface UnsafeCategoryDistributionProps {
  breakdownType: BreakdownTypeEnum;
  sensitiveTopicData: TopSensitiveTopicsType[];
  startDate: string;
  endDate: string;
}

export const UnsafeCategoryDistribution = ({
  breakdownType,
  sensitiveTopicData,
  startDate,
  endDate,
}: UnsafeCategoryDistributionProps) => {
  const categoryDataList: TopSensitiveTopicsType[] = [];

  if (!sensitiveTopicData) {
    return <> </>;
  }

  sensitiveTopicData.map((sensitiveTopic) => {
    const { __typename, ...sensitiveTopicDistribution } = sensitiveTopic;
    categoryDataList.push(sensitiveTopicDistribution);
  });

  const dataTableProps = {
    data: categoryDataList,
    columns: ["Category", "Impressions", "Impression Share"],
    breakdownType: breakdownType,
  };

  // Transform exampleData to match the expected props
  const transformedData = categoryDataList.map((edge) => ({
    category: `${edge.sensitiveTopic} (${returnRoundedNumber(edge.unsafeImpressionShare)}%)`,
    impressions:
      returnRoundedNumber(edge.unsafeImpressionShare),
  }));

  return (
    <Flex direction={"column"}>
      <DateRangeBox twoWeeksAgoDate={startDate} endDate={endDate} />
      <Flex>
        <SectionBox
          p={2}
          m={4}
          width="50%"
          display="flex"
          justifyContent="center"
          alignItems="center"
          backgroundColor={"#eef7f7"}
        >
          <CategoryImpressionsTable dataTableProps={dataTableProps} />
        </SectionBox>
        <SectionBox p={2} m={4} pl={30} width={"50%"}>
          <CircleChart transformedData={transformedData} dataColours={true} />
        </SectionBox>
      </Flex>
    </Flex>
  );
};
